<ng-container>
  <ng-content select="[priceBefore]"></ng-content>
  {{ price | priceCurrency : (currency$ | async) : (locale$ | async) }}
</ng-container>
